// extracted by mini-css-extract-plugin
export default {"wrapper":"ZonePropertiesForm_wrapper__bo3W6"};